import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init, fetching } = createAllActions(types.SCOPE);

const setInterval = (interval) => ({
  type: types.SET_INTERVAL,
  ...interval,
});

const setInitialData = (payload) => ({
  type: types.SET_INITIAL_DATA,
  payload,
});

export { init, fetching, setInterval, setInitialData };
